/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** Image custom scalar type */
  Date: { input: any; output: any };
  /** Image custom scalar type */
  DateTime: { input: any; output: any };
  /** Arbitrary JSON value */
  JSON: { input: any; output: any };
  /** URL custom scalar type */
  URL: { input: any; output: any };
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any };
};

/** An actor. */
export type Actor = {
  __typename?: "Actor";
  fullName: Scalars["String"]["output"];
  gender?: Maybe<Gender>;
  id: Scalars["ID"]["output"];
  image: ImageSizes;
  /** Number of published shows the actor appears in, visible in the user's market (same list as actorShows, current show included). */
  showsCount: Scalars["Int"]["output"];
};

/** A human age */
export enum Age {
  Btw_18_24 = "btw_18_24",
  Btw_18_34 = "btw_18_34",
  Btw_25_34 = "btw_25_34",
  Btw_35_44 = "btw_35_44",
  Btw_35_55 = "btw_35_55",
  Btw_45_54 = "btw_45_54",
  Over_55 = "over_55",
  Under_18 = "under_18",
}

/** Authentication result */
export type Auth = {
  __typename?: "Auth";
  /** The token of the authentication. */
  token: Scalars["String"]["output"];
  /** The user of the authentication. */
  user: User;
};

/** A badge type */
export enum BadgeType {
  New = "New",
  None = "None",
  OnSale = "OnSale",
}

/** A recently viewed show. */
export type BookmarkedShow = OrderedShow & {
  __typename?: "BookmarkedShow";
  order: Scalars["Int"]["output"];
  show: Show;
};

/** A behind-the-scenes video of a show, reserved to VIP users. */
export type Bts = {
  __typename?: "Bts";
  displayTitle: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  length: Scalars["Int"]["output"];
  /** True for non-VIP users; url is then null. */
  locked: Scalars["Boolean"]["output"];
  position: Scalars["Int"]["output"];
  thumbnail: ImageSizes;
  title: Scalars["String"]["output"];
  /** HLS playlist of the video. Null when locked. */
  url?: Maybe<Scalars["URL"]["output"]>;
};

/** A carousel section layout */
export type CarouselSectionLayout = {
  __typename?: "CarouselSectionLayout";
  type: Scalars["String"]["output"];
  variation: CarouselVariation;
};

/** A counter size */
export enum CarouselVariation {
  Classic = "Classic",
  Hero = "Hero",
}

/** A catalog layout template */
export type CatalogLayout = {
  __typename?: "CatalogLayout";
  tabs: Array<CatalogTabLayout>;
};

/** A tab template of the home page */
export type CatalogTabLayout = {
  __typename?: "CatalogTabLayout";
  displayTitle: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
  sections: Array<SectionLayout>;
  title: Scalars["String"]["output"];
};

/** A category of stories. */
export type Category = {
  __typename?: "Category";
  displayName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  order: Scalars["Int"]["output"];
  shows: Array<SectionShow>;
};

/** A checkpoint reward that is unlocked when a user reaches a specific checkpoint. */
export type CheckpointReward = Reward & {
  __typename?: "CheckpointReward";
  checkpoint: Scalars["Int"]["output"];
  doubleable: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  progression: RewardProgression;
  status: RewardStatus;
  type: RewardType;
  value: Scalars["Int"]["output"];
};

/** Keyset-paginated coins history (newest first), including synthesized expiration rows. */
export type CoinsHistoryConnection = {
  __typename?: "CoinsHistoryConnection";
  hasMore: Scalars["Boolean"]["output"];
  items: Array<CoinsHistoryItem>;
  /** Opaque cursor to pass back as `after` to fetch the next page; null when there are no more. */
  nextCursor?: Maybe<Scalars["String"]["output"]>;
};

/** Common fields of a coins-history row. */
export type CoinsHistoryEntry = {
  /** Coins moved — positive for an earn, negative for a spend or an expiration */
  amount: Scalars["Int"]["output"];
  /** When the entry happened (full instant) */
  occurredAt: Scalars["DateTime"]["output"];
  /** Display-ready row title, translated in the user's language */
  title: Scalars["String"]["output"];
  /** Kind of entry — which balance it affects / what happened (drives the row styling client-side) */
  type: CoinsTransactionType;
};

/** A row of the user's coins history. */
export type CoinsHistoryItem =
  | ExpiredCoinsEntry
  | GiftCoinsEntry
  | PurchasedCoinsEntry
  | RewardEarnEntry
  | SpentCoinsEntry
  | TransferCoinsEntry;

/** Kind of coins-history entry — which balance it affects / what happened (drives the row styling client-side). */
export enum CoinsTransactionType {
  Expired = "EXPIRED",
  Gift = "GIFT",
  Purchased = "PURCHASED",
  Reward = "REWARD",
  Spent = "SPENT",
  Transfer = "TRANSFER",
}

/** A column section layout */
export type ColumnSectionLayout = {
  __typename?: "ColumnSectionLayout";
  type: Scalars["String"]["output"];
};

/** A coming soon cover layout */
export type ComingSoonCoverLayout = {
  __typename?: "ComingSoonCoverLayout";
  type: Scalars["String"]["output"];
};

/** A counter size */
export enum CounterSize {
  Big = "Big",
  Small = "Small",
  XSmall = "XSmall",
}

/** A cover layout */
export type CoverLayout =
  | ComingSoonCoverLayout
  | DefaultCoverLayout
  | FeaturedCoverLayout;

/** A cover rank size */
export enum CoverRankType {
  Primary = "Primary",
  Secondary = "Secondary",
  Tertiary = "Tertiary",
}

/** A cover size */
export enum CoverSize {
  Large = "Large",
  Medium = "Medium",
  Small = "Small",
  XSmall = "xSmall",
}

/** The custom select action for a show layout */
export enum CustomSelectAction {
  RedirectToComingSoonPreview = "REDIRECT_TO_COMING_SOON_PREVIEW",
  RedirectToDetailsPage = "REDIRECT_TO_DETAILS_PAGE",
  ViewShow = "VIEW_SHOW",
}

/** The custom view all action for a section layout */
export enum CustomViewAllAction {
  RedirectToMyListRecentlyViewed = "REDIRECT_TO_MY_LIST_RECENTLY_VIEWED",
  ViewAll = "VIEW_ALL",
}

/** Register fields */
export type DeepLinkInput = {
  linkId: Scalars["ID"]["input"];
};

/** A default cover layout */
export type DefaultCoverLayout = {
  __typename?: "DefaultCoverLayout";
  badge: Scalars["Boolean"]["output"];
  counterSize?: Maybe<CounterSize>;
  previewUrl: Scalars["Boolean"]["output"];
  progression: Scalars["Boolean"]["output"];
  rankType?: Maybe<CoverRankType>;
  size: CoverSize;
  titleImage: Scalars["Boolean"]["output"];
};

/** A default ordered show. */
export type DefaultOrderedShow = OrderedShow & {
  __typename?: "DefaultOrderedShow";
  order: Scalars["Int"]["output"];
  show: Show;
};

/** A detail cover placement */
export enum DetailCoverPlacement {
  Bottom = "Bottom",
  Left = "Left",
  Right = "Right",
  Top = "Top",
}

/** A details layout */
export type DetailsLayout = {
  __typename?: "DetailsLayout";
  episodeCount: Scalars["Boolean"]["output"];
  placement: DetailCoverPlacement;
  rankType?: Maybe<CoverRankType>;
  tag: Scalars["Boolean"]["output"];
  title: Scalars["Boolean"]["output"];
};

/** The type of device. */
export enum DeviceType {
  Android = "ANDROID",
  Ios = "IOS",
  Web = "WEB",
}

/** An entitlement granted by a subscription product. */
export enum Entitlement {
  OfflineDownload = "OFFLINE_DOWNLOAD",
  Premium = "PREMIUM",
}

/** An episode. */
export type Episode = {
  __typename?: "Episode";
  /** ISO 639-3 codes of the dubbed audio tracks available on this episode (source language excluded). Empty when not dubbed. */
  audioLanguages: Array<Scalars["String"]["output"]>;
  creditsAt?: Maybe<Scalars["Int"]["output"]>;
  free: Scalars["Boolean"]["output"];
  /** True when the media URL uses the nested playlist layout (encoded with timeline thumbnails). */
  hasTimelineThumbnails: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  length: Scalars["Int"]["output"];
  /** [AUTHENTICATED] */
  liked: Scalars["Boolean"]["output"];
  likes: Scalars["Int"]["output"];
  number: Scalars["Int"]["output"];
  price: Scalars["Int"]["output"];
  /** [AUTHENTICATED] */
  unlocked: Scalars["Boolean"]["output"];
  url: Scalars["URL"]["output"];
  views: Scalars["Int"]["output"];
  /** [AUTHENTICATED] */
  watched: Scalars["Boolean"]["output"];
};

/** Event input */
export type EventInput = {
  openFromSearch?: InputMaybe<EventOpenFromSearchInput>;
  openShow?: InputMaybe<EventOpenShowInput>;
};

/** Open from search event input */
export type EventOpenFromSearchInput = {
  searchQuery: Scalars["String"]["input"];
  showId: Scalars["ID"]["input"];
};

/** Open show event input */
export type EventOpenShowInput = {
  impressions: Array<Scalars["ID"]["input"]>;
  recommendationId?: InputMaybe<Scalars["String"]["input"]>;
  sectionId: Scalars["ID"]["input"];
  showId: Scalars["ID"]["input"];
};

/** Synthesized row: earned reward coins that lapsed unspent (not a real ledger event). */
export type ExpiredCoinsEntry = CoinsHistoryEntry & {
  __typename?: "ExpiredCoinsEntry";
  amount: Scalars["Int"]["output"];
  /** When the expired coins had originally been claimed */
  claimedAt: Scalars["DateTime"]["output"];
  occurredAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  type: CoinsTransactionType;
};

/** A featured cover layout */
export type FeaturedCoverLayout = {
  __typename?: "FeaturedCoverLayout";
  type: Scalars["String"]["output"];
};

/** A human gender */
export enum Gender {
  Female = "female",
  Male = "male",
  NonBinary = "non_binary",
}

/** Coins gifted to the user by the team. */
export type GiftCoinsEntry = CoinsHistoryEntry & {
  __typename?: "GiftCoinsEntry";
  amount: Scalars["Int"]["output"];
  occurredAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  type: CoinsTransactionType;
};

/** Google OAuth parameters. */
export type GoogleOAuthParameters = {
  __typename?: "GoogleOAuthParameters";
  accessToken?: Maybe<Scalars["String"]["output"]>;
  expiresIn?: Maybe<Scalars["String"]["output"]>;
  idToken?: Maybe<Scalars["String"]["output"]>;
  refreshToken?: Maybe<Scalars["String"]["output"]>;
  scope?: Maybe<Scalars["String"]["output"]>;
  tokenType?: Maybe<Scalars["String"]["output"]>;
};

/** A horizontal grid section layout */
export type HorizontalGridSectionLayout = {
  __typename?: "HorizontalGridSectionLayout";
  rows: Scalars["Int"]["output"];
};

/** The type of IAP product. */
export enum IapPaywall {
  Cancellation = "CANCELLATION",
  DownloadFree = "DOWNLOAD_FREE",
  DownloadWeekly = "DOWNLOAD_WEEKLY",
  Onboarding = "ONBOARDING",
  Retention = "RETENTION",
  SeriesDetails = "SERIES_DETAILS",
  Shop = "SHOP",
  UnlockEpisodePopUp = "UNLOCK_EPISODE_POP_UP",
  UnlockEpisodeShop = "UNLOCK_EPISODE_SHOP",
  Upsell = "UPSELL",
  VipShop = "VIP_SHOP",
  Winback = "WINBACK",
}

/** The type of IAP product. */
export enum IapPeriodicity {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Once = "ONCE",
  Unknown = "UNKNOWN",
  Weekly = "WEEKLY",
  Yearly = "YEARLY",
  YearlyRecurring = "YEARLY_RECURRING",
}

/** An IAP product. */
export type IapProduct = {
  __typename?: "IAPProduct";
  bonus?: Maybe<Scalars["Int"]["output"]>;
  coins?: Maybe<Scalars["Int"]["output"]>;
  entitlements: Array<Entitlement>;
  id: Scalars["ID"]["output"];
  isCurrentSubscription: Scalars["Boolean"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  isFeatured: Scalars["Boolean"]["output"];
  isFeaturedDisplayable: Scalars["Boolean"]["output"];
  isHighlight: Scalars["Boolean"]["output"];
  marketingTag?: Maybe<Scalars["String"]["output"]>;
  marketingTagAlt?: Maybe<Scalars["String"]["output"]>;
  paywalls: Array<IapPaywall>;
  /** Store platform of the product: ANDROID, IOS or WEB (Stripe products sold through RevenueCat and IZI products are WEB products). */
  platform: DeviceType;
  productId: Scalars["String"]["output"];
  promotionalReplacingProductId?: Maybe<Scalars["String"]["output"]>;
  /** Platform a subscription bought on this product is stored as on the user (same values as UserSubscription.subscriptionPlatform): A2W for a Stripe product sold through RevenueCat, WEB for an IZI Web Checkout product, IOS / ANDROID for store products. */
  subscriptionPlatform: SubscriptionPlatform;
  type: IapProductType;
  winbackReplacingProductId?: Maybe<Scalars["String"]["output"]>;
};

/** The type of IAP product. */
export enum IapProductType {
  Consumable = "CONSUMABLE",
  NonConsumable = "NON_CONSUMABLE",
  Subscription = "SUBSCRIPTION",
}

/** An IAP promotion. */
export type IapPromotion = {
  __typename?: "IAPPromotion";
  badgeImageUrl: ImageSizes;
  bannerImageUrl: ImageSizes;
  bgGradientEnd: Scalars["String"]["output"];
  bgGradientStart: Scalars["String"]["output"];
  endAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  labelPrimary: Scalars["String"]["output"];
  labelPrimaryColor: Scalars["String"]["output"];
  labelSecondary: Scalars["String"]["output"];
  labelSecondaryColor: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  promoGradientEnd: Scalars["String"]["output"];
  promoGradientStart: Scalars["String"]["output"];
  savedPercentage: Scalars["Float"]["output"];
  startAt: Scalars["DateTime"]["output"];
};

/** The various sizes of an image. */
export type ImageSizes = {
  __typename?: "ImageSizes";
  /** The large version of the image. */
  large: Scalars["String"]["output"];
  /** The medium version of the image. */
  medium: Scalars["String"]["output"];
  /** The original image. */
  original: Scalars["String"]["output"];
  /** The small version of the image. */
  small: Scalars["String"]["output"];
};

/** Migrate reward input */
export type MigrateRewardInput = {
  claimable?: InputMaybe<Scalars["Boolean"]["input"]>;
  streak?: InputMaybe<Scalars["Int"]["input"]>;
  type: RewardType;
};

/** A most trending show. */
export type MostTrendingShow = OrderedShow & {
  __typename?: "MostTrendingShow";
  order: Scalars["Int"]["output"];
  show: Show;
};

export type Mutation = {
  __typename?: "Mutation";
  /** [AUTHENTICATED] Bookmark a show */
  bookmark: Array<Show>;
  /** [AUTHENTICATED] Claim a reward. */
  claimReward: Array<Reward>;
  /** [AUTHENTICATED] Delete your account */
  deleteAccount: Auth;
  /** [AUTHENTICATED] Like an episode */
  like: Episode;
  /** [AUTHENTICATED] Link Apple social provider to the user */
  linkAppleProvider: Auth;
  /** [AUTHENTICATED] Link Email social provider to the user */
  linkEmailProvider: Auth;
  /** [AUTHENTICATED] Link Facebook social provider to the user */
  linkFacebookProvider: Auth;
  /** [AUTHENTICATED] Link Google social provider to the user */
  linkGoogleProvider: Auth;
  /** [AUTHENTICATED] Logout the user */
  logout: Auth;
  /**
   * [AUTHENTICATED] Migrate coins from front to backend
   * @deprecated Not used anymore
   */
  migrateCoins: User;
  /** [AUTHENTICATED] Migrate rewards */
  migrateRewards: Scalars["Boolean"]["output"];
  /** Register a new user */
  register: Auth;
  /** [AUTHENTICATED] Restore a purchase */
  restorePurchase: Scalars["Boolean"]["output"];
  /** [AUTHENTICATED] Link Email social provider to the user */
  sendEmailLink: Scalars["Boolean"]["output"];
  /** [AUTHENTICATED] Register a new user */
  setupDeepLinkId: Scalars["Boolean"]["output"];
  /** [AUTHENTICATED] Track an event */
  trackEvent: Scalars["Boolean"]["output"];
  /** [AUTHENTICATED] Un-bookmark a show */
  unbookmark: Array<Show>;
  /** [AUTHENTICATED] Unlike an episode */
  unlike: Episode;
  /** Unlink a social provider from the user */
  unlinkSocialProvider: User;
  /** [AUTHENTICATED] Unlock an episode */
  unlocked: Episode;
  /** [AUTHENTICATED] Unlock an episode */
  unlockedList: Array<Episode>;
  /** [AUTHENTICATED] Un-track shows from the Continue Watching section. */
  untrack: Array<Show>;
  /** [AUTHENTICATED] Update profile fields */
  updateProfile: User;
  /** An episode has been watched. */
  watched: Scalars["Boolean"]["output"];
};

export type MutationBookmarkArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationClaimRewardArgs = {
  type: RewardType;
};

export type MutationLikeArgs = {
  id: Scalars["ID"]["input"];
  percentage: Scalars["Float"]["input"];
};

export type MutationLinkAppleProviderArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerInput: SocialProviderInput;
};

export type MutationLinkEmailProviderArgs = {
  email: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  providerInput: SocialProviderInput;
};

export type MutationLinkFacebookProviderArgs = {
  providerInput: SocialProviderInput;
};

export type MutationLinkGoogleProviderArgs = {
  providerInput: SocialProviderInput;
};

export type MutationMigrateCoinsArgs = {
  coins: Scalars["Int"]["input"];
};

export type MutationMigrateRewardsArgs = {
  input: Array<MigrateRewardInput>;
};

export type MutationRegisterArgs = {
  input: RegisterInput;
};

export type MutationSendEmailLinkArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationSetupDeepLinkIdArgs = {
  input: DeepLinkInput;
};

export type MutationTrackEventArgs = {
  event: EventInput;
};

export type MutationUnbookmarkArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationUnlikeArgs = {
  id: Scalars["ID"]["input"];
  percentage: Scalars["Float"]["input"];
};

export type MutationUnlinkSocialProviderArgs = {
  provider: SocialProvider;
};

export type MutationUnlockedArgs = {
  coins?: InputMaybe<Scalars["Int"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type MutationUnlockedListArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationUntrackArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationUpdateProfileArgs = {
  params: UpdateProfileInput;
};

export type MutationWatchedArgs = {
  id: Scalars["ID"]["input"];
};

/** A one-time reward that can only be claimed once. */
export type OneTimeReward = Reward & {
  __typename?: "OneTimeReward";
  doubleable: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  status: RewardStatus;
  type: RewardType;
  value: Scalars["Int"]["output"];
};

/** An interface for shows that can be ordered */
export type OrderedShow = {
  order: Scalars["Int"]["output"];
  show: Show;
};

/** A carousel section layout */
export type PagerSectionLayout = {
  __typename?: "PagerSectionLayout";
  type: Scalars["String"]["output"];
};

/** A paginated list of products. */
export type PaginatedIapProducts = {
  __typename?: "PaginatedIAPProducts";
  /** The IAP products. */
  products: Array<IapProduct>;
  /** The total number of IAP products. */
  total: Scalars["Int"]["output"];
};

/** The current user's assignment for one paywall experiment, for client-side exposure tracking. */
export type PaywallExperimentAssignment = {
  __typename?: "PaywallExperimentAssignment";
  /** Amplitude flag key to report exposure against. */
  flagKey: Scalars["String"]["output"];
  /** Platforms this experiment runs on. */
  platforms: Array<DeviceType>;
  /** Paywall surfaces governed by this experiment. */
  surfaces: Array<IapPaywall>;
  /** Variant the user is assigned to. Falls back to the control arm. */
  variantKey: Scalars["String"]["output"];
};

/** Regular and reward balances updated */
export type Premium = {
  __typename?: "Premium";
  /** @deprecated Use subscriptionPlatform, which distinguishes app-to-web (A2W) subscriptions. */
  platform: DeviceType;
  productId: Scalars["String"]["output"];
  subscriptionPlatform: SubscriptionPlatform;
};

/** A show's progression. */
export type Progression = {
  __typename?: "Progression";
  completed: Scalars["Boolean"]["output"];
  lastViewedAt?: Maybe<Scalars["DateTime"]["output"]>;
  nextEpisode?: Maybe<Episode>;
  /** The progress of the show from 0 to 1. */
  progress: Scalars["Float"]["output"];
  total: Scalars["Int"]["output"];
};

/** A pack of coins bought by the user. */
export type PurchasedCoinsEntry = CoinsHistoryEntry & {
  __typename?: "PurchasedCoinsEntry";
  amount: Scalars["Int"]["output"];
  /** Price paid, formatted in the user's language and purchase currency (e.g. "4,99 €") — null when no displayable price */
  formattedPrice?: Maybe<Scalars["String"]["output"]>;
  occurredAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  type: CoinsTransactionType;
};

export type Query = {
  __typename?: "Query";
  /** [AUTHENTICATED] Paywall experiments governing this user, so the client can report exposure */
  activePaywallExperiments: Array<PaywallExperimentAssignment>;
  /** [AUTHENTICATED] Published shows an actor appears in (most recent first), for the cast member page. */
  actorShows: Array<Show>;
  /** [AUTHENTICATED] Get a list of bookmarked shows */
  bookmarkedShows: Array<BookmarkedShow>;
  /** [NOT EMPTY] Get the home sections */
  catalogLayout: CatalogLayout;
  /** [NOT EMPTY] Get all categories */
  categories: Array<Category>;
  /** [AUTHENTICATED] Paginated history of the current user's coins — earns, purchases, spends and synthesized expiration rows (newest first). */
  coinsHistory: CoinsHistoryConnection;
  /** [AUTHENTICATED] The favorite tags of the user */
  favoriteTags: Array<Scalars["String"]["output"]>;
  /** [NOT EMPTY] [AUTHENTICATED] The shows that are recommended for the user */
  forYou: Array<SectionShow>;
  /** [AUTHENTICATED] Verify social provider */
  getGoogleOAuthParameters: GoogleOAuthParameters;
  /** [NOT EMPTY] Get the home sections */
  home: Array<Section>;
  /** [AUTHENTICATED] Get IAP products */
  iapProducts: Array<IapProduct>;
  /** [AUTHENTICATED] Get the total coins available from claimable rewards today */
  incentiveRewards: Scalars["Int"]["output"];
  /** [AUTHENTICATED] Get the current user. */
  me: User;
  /** Get the most trending shows. */
  mostTrending: Array<MostTrendingShow>;
  /** [AUTHENTICATED] Generate a OneLink deeplink URL for the authenticated user. */
  oneLinkDeeplinkUrl: Scalars["String"]["output"];
  /** [AUTHENTICATED] The popular search query. */
  popularSearch: Array<SectionShow>;
  /** [AUTHENTICATED] Get IAP products */
  promotion?: Maybe<IapPromotion>;
  /** [AUTHENTICATED] Get a list of recently viewed shows */
  recentlyViewed: Array<RecentlyViewedShow>;
  /** [AUTHENTICATED] The shows that are recommended for the user for this show */
  recommendationByType: Array<RecommendedShow>;
  /** [NOT EMPTY] [AUTHENTICATED] The shows that are recommended for the user for this show */
  recommended: Array<RecommendedShow>;
  /** [AUTHENTICATED] The content of a section */
  recommendedSectionContent: SectionRecommendedContent;
  /** [AUTHENTICATED] Shows related to a show, for the Recommendations section of the series page. */
  relatedShows: RelatedShowsResult;
  /** [AUTHENTICATED] The list of rewards */
  rewards: Array<Reward>;
  /** Search for shows */
  search: Array<SearchShow>;
  /** [AUTHENTICATED] Get tappable tags for search */
  searchTags: Array<Scalars["String"]["output"]>;
  /** [AUTHENTICATED] The content of a section */
  sectionContent: SectionContent;
  /** Get a show */
  show: Show;
  /** Get all shows */
  shows: Array<Show>;
  /** [AUTHENTICATED] Get the support token for the current user. */
  supportToken: SupportToken;
  /** [AUTHENTICATED] Verify social provider */
  verifySocialProvider?: Maybe<User>;
  /** [AUTHENTICATED] Get the yearly wrapped (yearly stats recap) for the current user. */
  yearlyWrapped?: Maybe<YearlyWrapped>;
};

export type QueryActorShowsArgs = {
  actorId: Scalars["ID"]["input"];
  excludeShowId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryCoinsHistoryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryGetGoogleOAuthParametersArgs = {
  code: Scalars["String"]["input"];
  redirectUri: Scalars["String"]["input"];
};

export type QueryRecommendationByTypeArgs = {
  categoryId?: InputMaybe<Scalars["ID"]["input"]>;
  engine: Scalars["String"]["input"];
  showId?: InputMaybe<Scalars["ID"]["input"]>;
  tag?: InputMaybe<Scalars["String"]["input"]>;
  type: RecommenderType;
};

export type QueryRecommendedArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryRelatedShowsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  showId: Scalars["ID"]["input"];
};

export type QuerySearchArgs = {
  query: Scalars["String"]["input"];
};

export type QuerySectionContentArgs = {
  all?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
};

export type QueryShowArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryShowsArgs = {
  exclusive?: InputMaybe<Scalars["Boolean"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryVerifySocialProviderArgs = {
  provider: SocialProvider;
  providerToken: Scalars["String"]["input"];
};

/** A recently viewed show. */
export type RecentlyViewedShow = OrderedShow & {
  __typename?: "RecentlyViewedShow";
  order: Scalars["Int"]["output"];
  show: Show;
};

/** A recommended show. */
export type RecommendedShow = OrderedShow & {
  __typename?: "RecommendedShow";
  mostTrendingRank?: Maybe<Scalars["Int"]["output"]>;
  order: Scalars["Int"]["output"];
  show: Show;
};

/** A recommender type */
export enum RecommenderType {
  BecauseYouWatchedX = "BECAUSE_YOU_WATCHED_X",
  MoreLikeX = "MORE_LIKE_X",
  MostPopular = "MOST_POPULAR",
  TopPicks = "TOP_PICKS",
  TrendingNow = "TRENDING_NOW",
}

/** Register fields */
export type RegisterInput = {
  uid: Scalars["ID"]["input"];
};

/** Regular and reward balances updated */
export type RegularAndRewardBalancesUpdated = {
  __typename?: "RegularAndRewardBalancesUpdated";
  regular: Scalars["Int"]["output"];
  reward: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

/** Paginated list of shows related to a show. */
export type RelatedShowsResult = {
  __typename?: "RelatedShowsResult";
  shows: Array<Show>;
  total: Scalars["Int"]["output"];
};

/** A reward. */
export type Reward = {
  doubleable: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** The status of the reward: claimed, claimable_locked, claimable, or locked. */
  status: RewardStatus;
  type: RewardType;
  value: Scalars["Int"]["output"];
};

/** An earn of reward coins — carries its expiry state. */
export type RewardEarnEntry = CoinsHistoryEntry & {
  __typename?: "RewardEarnEntry";
  amount: Scalars["Int"]["output"];
  /** When these reward coins expire */
  expireAt: Scalars["DateTime"]["output"];
  /** Whether this batch is already past its expiry */
  isExpired: Scalars["Boolean"]["output"];
  occurredAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  type: CoinsTransactionType;
};

/** Tracks progression for checkpoint-based rewards. */
export type RewardProgression = {
  __typename?: "RewardProgression";
  current: Scalars["Int"]["output"];
  total: Scalars["Int"]["output"];
};

/** The status of a reward. */
export enum RewardStatus {
  Claimable = "claimable",
  ClaimableLocked = "claimable_locked",
  Claimed = "claimed",
  Locked = "locked",
}

/** The type of reward. */
export enum RewardType {
  Ads = "ads",
  CheckIn = "checkIn",
  ConnectApple = "connect_apple",
  ConnectEmail = "connect_email",
  ConnectFb = "connect_fb",
  ConnectGoogle = "connect_google",
  FollowFb = "follow_fb",
  FollowIg = "follow_ig",
  FollowTt = "follow_tt",
  FollowYt = "follow_yt",
  Improve = "improve",
  Notifications = "notifications",
  Review = "review",
  Watch = "watch",
  Welcome = "welcome",
}

/** A row section layout */
export type RowSectionLayout = {
  __typename?: "RowSectionLayout";
  type: Scalars["String"]["output"];
};

/** A search show result. */
export type SearchShow = OrderedShow & {
  __typename?: "SearchShow";
  order: Scalars["Int"]["output"];
  show: Show;
};

/** A section of the home page */
export type Section = {
  __typename?: "Section";
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
  sectionType: SectionType;
  shows: Array<SectionShow>;
  title: Scalars["String"]["output"];
};

/** The content of a section */
export type SectionContent = {
  __typename?: "SectionContent";
  recommendationId?: Maybe<Scalars["String"]["output"]>;
  shows: Array<DefaultOrderedShow>;
};

/** A section of the home page */
export type SectionLayout = {
  __typename?: "SectionLayout";
  content?: Maybe<SectionContent>;
  customViewAllActions?: Maybe<CustomViewAllAction>;
  displayTitle?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
  showLayout: ShowLayout;
  title: Scalars["String"]["output"];
  toRefresh: Scalars["Boolean"]["output"];
  type: SectionLayoutType;
  viewAll: Scalars["Boolean"]["output"];
};

/** A section of the home page */
export type SectionLayoutType =
  | CarouselSectionLayout
  | ColumnSectionLayout
  | HorizontalGridSectionLayout
  | PagerSectionLayout
  | RowSectionLayout
  | VerticalGridSectionLayout;

/** The content of a section */
export type SectionRecommendedContent = {
  __typename?: "SectionRecommendedContent";
  recommendationId?: Maybe<Scalars["String"]["output"]>;
  shows: Array<RecommendedShow>;
};

/** A section show. */
export type SectionShow = OrderedShow & {
  __typename?: "SectionShow";
  /** @deprecated Use `show` instead */
  categories: Array<Category>;
  /** @deprecated Use `show` instead */
  createdAt: Scalars["DateTime"]["output"];
  /** @deprecated Use `show` instead */
  description: Scalars["String"]["output"];
  /** @deprecated Use `show` instead */
  displayTitle: Scalars["String"]["output"];
  /** @deprecated Use `show` instead */
  episodes: Array<Episode>;
  /** @deprecated Use `show` instead */
  horizontalThumbnail?: Maybe<ImageSizes>;
  /** @deprecated Use `show` instead */
  id: Scalars["ID"]["output"];
  /** @deprecated Use `show` instead */
  image: ImageSizes;
  /** @deprecated Use `show` instead */
  isExclusive: Scalars["Boolean"]["output"];
  /** @deprecated Use `show` instead */
  isFeatured: Scalars["Boolean"]["output"];
  order: Scalars["Int"]["output"];
  /**
   * [AUTHENTICATED]
   * @deprecated Use `show` instead
   */
  progression: Progression;
  /** @deprecated Use `show` instead */
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  show: Show;
  /** @deprecated Use `show` instead */
  tags: Array<Scalars["String"]["output"]>;
  /** @deprecated Use `show` instead */
  thumbnail: ImageSizes;
  /** @deprecated Use `show` instead */
  title: Scalars["String"]["output"];
  /** @deprecated Use `show` instead */
  titleImage: ImageSizes;
  /** @deprecated Use `show` instead */
  views: Scalars["Int"]["output"];
};

/** The type of content for a section */
export enum SectionType {
  Classic = "classic",
  Coming = "coming",
  Continue = "continue",
  /** Shows dubbed in the user's language, newest release first */
  Dubbed = "dubbed",
  Exclusive = "exclusive",
  Featured = "featured",
  Grid = "grid",
  LimitedTimeDeals = "limited_time_deals",
  MightLove = "might_love",
  NewShows = "new_shows",
  Picks = "picks",
  PopularSearch = "popular_search",
  Sale = "sale",
  TopByCategoriesOrTags = "top_by_categories_or_tags",
  Trending = "trending",
  TrendingToday = "trending_today",
}

/** A show. */
export type Show = {
  __typename?: "Show";
  /** Actors of the show ordered by position (empty when no actor is attached). */
  actors: Array<Actor>;
  /** ISO 639-3 codes of the dubbed audio languages available on at least one episode (source language excluded). Empty when the show is not dubbed. */
  audioLanguages: Array<Scalars["String"]["output"]>;
  badgeType: BadgeType;
  /** Published behind-the-scenes videos ordered by position, each with a thumbnail and a title (empty when the show has none; the client hides the section). */
  behindTheScenes: Array<Bts>;
  bookmarks: Scalars["Int"]["output"];
  categories: Array<Category>;
  createdAt: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  directors: Array<Scalars["String"]["output"]>;
  displayDescription: Scalars["String"]["output"];
  displayHorizontalThumbnail?: Maybe<ImageSizes>;
  displayImage: ImageSizes;
  /** Long synopsis in the request locale (falls back to en, then to the source text). Null while longDescription is not filled: clients fall back to displayDescription. */
  displayLongDescription?: Maybe<Scalars["String"]["output"]>;
  /** [NOT EMPTY] */
  displayTags: Array<Scalars["String"]["output"]>;
  displayThumbnail: ImageSizes;
  displayTitle: Scalars["String"]["output"];
  displayTitleImage: ImageSizes;
  episodes: Array<Episode>;
  episodesCount: Scalars["Int"]["output"];
  horizontalThumbnail?: Maybe<ImageSizes>;
  id: Scalars["ID"]["output"];
  image: ImageSizes;
  /** [AUTHENTICATED] */
  isBookmarked: Scalars["Boolean"]["output"];
  isExclusive: Scalars["Boolean"]["output"];
  /** @deprecated Don't use this field anymore */
  isFeatured: Scalars["Boolean"]["output"];
  leadActors: Array<Scalars["String"]["output"]>;
  likes: Scalars["Int"]["output"];
  /** Long synopsis (200-300 words) for the website series pages, source language. Null until the editorial team fills it: clients fall back to description. */
  longDescription?: Maybe<Scalars["String"]["output"]>;
  market: Array<Scalars["String"]["output"]>;
  /** 1-based rank of the show in the mostTrending list (top 10 for this user); null when it is not in it or when the ranking is unavailable. */
  mostTrendingRank?: Maybe<Scalars["Int"]["output"]>;
  onSale: Scalars["Boolean"]["output"];
  producers: Array<Scalars["String"]["output"]>;
  /** [AUTHENTICATED] */
  progression: Progression;
  publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** [NOT EMPTY] */
  tags: Array<Scalars["String"]["output"]>;
  thumbnail: ImageSizes;
  title: Scalars["String"]["output"];
  titleImage: ImageSizes;
  trailer?: Maybe<Episode>;
  /** Hidden from every listing surface; only reachable by direct link */
  unlisted: Scalars["Boolean"]["output"];
  unpublishedAt?: Maybe<Scalars["DateTime"]["output"]>;
  views: Scalars["Int"]["output"];
  writers: Array<Scalars["String"]["output"]>;
};

/** A show layout */
export type ShowLayout = {
  __typename?: "ShowLayout";
  coverLayout: CoverLayout;
  customSelectActions?: Maybe<CustomSelectAction>;
  detailsLayout?: Maybe<DetailsLayout>;
};

/** Social provider */
export enum SocialProvider {
  Apple = "APPLE",
  Email = "EMAIL",
  Facebook = "FACEBOOK",
  Google = "GOOGLE",
}

/** Social provider */
export type SocialProviderInput = {
  providerRefreshToken?: InputMaybe<Scalars["String"]["input"]>;
  providerToken: Scalars["String"]["input"];
};

/** Coins spent by the user (e.g. unlocking an episode). */
export type SpentCoinsEntry = CoinsHistoryEntry & {
  __typename?: "SpentCoinsEntry";
  amount: Scalars["Int"]["output"];
  occurredAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  type: CoinsTransactionType;
};

export type Subscription = {
  __typename?: "Subscription";
  /** [AUTHENTICATED] Balance updated */
  balanceUpdated: Scalars["Int"]["output"];
  /** [AUTHENTICATED] Balance updated */
  balancesUpdated: RegularAndRewardBalancesUpdated;
  /** [AUTHENTICATED] Premium data updated */
  premium?: Maybe<Premium>;
  /** [AUTHENTICATED] Premium updated */
  premiumUpdated: Scalars["Boolean"]["output"];
  /** [AUTHENTICATED] Premium data updated */
  subscriptionUpdated?: Maybe<UserSubscription>;
};

/**
 * The platform a subscription was purchased on.
 * A2W (app-to-web) is a Stripe subscription purchased from inside the mobile app and reported by RevenueCat;
 * WEB is a subscription purchased on the web app (IZI web checkout).
 */
export enum SubscriptionPlatform {
  A2W = "A2W",
  Android = "ANDROID",
  Ios = "IOS",
  Web = "WEB",
}

/** A support token. */
export type SupportToken = {
  __typename?: "SupportToken";
  token: Scalars["String"]["output"];
};

/** A balance movement between accounts or systems (account merge, migration, balance fix). */
export type TransferCoinsEntry = CoinsHistoryEntry & {
  __typename?: "TransferCoinsEntry";
  amount: Scalars["Int"]["output"];
  occurredAt: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  type: CoinsTransactionType;
};

/** Update profile fields */
export type UpdateProfileInput = {
  age?: InputMaybe<Age>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Gender>;
  interests?: InputMaybe<Array<Scalars["String"]["input"]>>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  subtitlesLang?: InputMaybe<Scalars["String"]["input"]>;
};

/** A user. */
export type User = {
  __typename?: "User";
  /** @deprecated Doesn't exist anymore */
  code: Scalars["ID"]["output"];
  coinsBalance: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isPremium: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  premium?: Maybe<Premium>;
  providers: Array<SocialProvider>;
  providersData: Array<UserSocialProvider>;
  referrers: Scalars["Int"]["output"];
  rewardsBalance: Scalars["Int"]["output"];
  subscription: UserSubscription;
  trackingId: Scalars["ID"]["output"];
  updatedAt: Scalars["Date"]["output"];
  views: Scalars["Int"]["output"];
};

/** A user social provider. */
export type UserSocialProvider = {
  __typename?: "UserSocialProvider";
  createdAt: Scalars["Date"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  provider: SocialProvider;
  updatedAt: Scalars["Date"]["output"];
};

/** User Subscription infos */
export type UserSubscription =
  | UserSubscriptionActive
  | UserSubscriptionDunning
  | UserSubscriptionInactive
  | UserSubscriptionPaused
  | UserSubscriptionRetention
  | UserSubscriptionWinback;

/** Premium active */
export type UserSubscriptionActive = {
  __typename?: "UserSubscriptionActive";
  entitlements: Array<Entitlement>;
  /** @deprecated Use subscriptionPlatform, which distinguishes app-to-web (A2W) subscriptions. */
  platform: DeviceType;
  productId: Scalars["String"]["output"];
  subscriptionPlatform: SubscriptionPlatform;
};

/** User Subscription active */
export type UserSubscriptionDunning = {
  __typename?: "UserSubscriptionDunning";
  entitlements: Array<Entitlement>;
  graceEndsAt: Scalars["DateTime"]["output"];
  /** @deprecated Use subscriptionPlatform, which distinguishes app-to-web (A2W) subscriptions. */
  platform: DeviceType;
  productId: Scalars["String"]["output"];
  subscriptionPlatform: SubscriptionPlatform;
};

/** User Subscription active */
export type UserSubscriptionInactive = {
  __typename?: "UserSubscriptionInactive";
  /** @deprecated Placeholder field because graphql do not support empty objects, do not use */
  _?: Maybe<Scalars["Boolean"]["output"]>;
};

/** User Subscription active */
export type UserSubscriptionPaused = {
  __typename?: "UserSubscriptionPaused";
  expiredAt: Scalars["DateTime"]["output"];
  /** @deprecated Use subscriptionPlatform, which distinguishes app-to-web (A2W) subscriptions. */
  platform: DeviceType;
  productId: Scalars["String"]["output"];
  subscriptionPlatform: SubscriptionPlatform;
};

/** User Subscription active */
export type UserSubscriptionRetention = {
  __typename?: "UserSubscriptionRetention";
  entitlements: Array<Entitlement>;
  expiresAt: Scalars["DateTime"]["output"];
  /** @deprecated Use subscriptionPlatform, which distinguishes app-to-web (A2W) subscriptions. */
  platform: DeviceType;
  productId: Scalars["String"]["output"];
  subscriptionPlatform: SubscriptionPlatform;
};

/** User Subscription active */
export type UserSubscriptionWinback = {
  __typename?: "UserSubscriptionWinback";
  expiredAt: Scalars["DateTime"]["output"];
  willExpireAt: Scalars["DateTime"]["output"];
};

/** A vertical grid section layout */
export type VerticalGridSectionLayout = {
  __typename?: "VerticalGridSectionLayout";
  columns: Scalars["Int"]["output"];
};

/** A section of the home page */
export type YearlyShortsWrapped = {
  __typename?: "YearlyShortsWrapped";
  mostWatchedShows: Array<Show>;
  topFemaleActor: Actor;
  topMaleActor: Actor;
  topTags: Array<Scalars["String"]["output"]>;
};

/** A section of the home page */
export type YearlyUserWrapped = {
  __typename?: "YearlyUserWrapped";
  mostWatchedShows: Array<Show>;
  percentile: Scalars["Int"]["output"];
  rank: Scalars["Int"]["output"];
  topFemaleActor: Actor;
  topMaleActor: Actor;
  topTags: Array<Scalars["String"]["output"]>;
  totalDurationWatched: Scalars["Int"]["output"];
  totalEpisodesWatched: Scalars["Int"]["output"];
  totalUsers: Scalars["Int"]["output"];
};

/** A section of the home page */
export type YearlyWrapped = {
  __typename?: "YearlyWrapped";
  recommendationId?: Maybe<Scalars["String"]["output"]>;
  recommendedShows: Array<DefaultOrderedShow>;
  shortsWrapped: YearlyShortsWrapped;
  userWrapped?: Maybe<YearlyUserWrapped>;
};

export type CatalogSectionFragmentFragment = {
  __typename?: "SectionLayout";
  id: string;
  displayTitle?: string | null;
  order: number;
  toRefresh: boolean;
  type:
    | { __typename: "CarouselSectionLayout"; variation: CarouselVariation }
    | { __typename: "ColumnSectionLayout" }
    | { __typename: "HorizontalGridSectionLayout"; rows: number }
    | { __typename: "PagerSectionLayout" }
    | { __typename: "RowSectionLayout" }
    | { __typename: "VerticalGridSectionLayout"; columns: number };
  showLayout: {
    __typename?: "ShowLayout";
    coverLayout:
      | { __typename: "ComingSoonCoverLayout" }
      | {
          __typename: "DefaultCoverLayout";
          size: CoverSize;
          badge: boolean;
          counterSize?: CounterSize | null;
          rankType?: CoverRankType | null;
          titleImage: boolean;
          progression: boolean;
        }
      | { __typename: "FeaturedCoverLayout" };
    detailsLayout?: {
      __typename?: "DetailsLayout";
      placement: DetailCoverPlacement;
      title: boolean;
      tag: boolean;
      rankType?: CoverRankType | null;
      episodeCount: boolean;
    } | null;
  };
  content?:
    | ({ __typename?: "SectionContent" } & {
        " $fragmentRefs"?: {
          SectionContentFragmentFragment: SectionContentFragmentFragment;
        };
      })
    | null;
} & { " $fragmentName"?: "CatalogSectionFragmentFragment" };

export type CatalogShowFragmentFragment = {
  __typename?: "Show";
  id: string;
  title: string;
  displayTitle: string;
  displayDescription: string;
  displayTags: Array<string>;
  views: number;
  episodesCount: number;
  publishedAt?: any | null;
  badgeType: BadgeType;
  isBookmarked?: boolean;
  displayThumbnail: {
    __typename?: "ImageSizes";
    original: string;
    medium: string;
  };
  displayHorizontalThumbnail?: {
    __typename?: "ImageSizes";
    original: string;
  } | null;
  displayImage: { __typename?: "ImageSizes"; original: string };
  displayTitleImage: { __typename?: "ImageSizes"; original: string };
  progression?: {
    __typename?: "Progression";
    progress: number;
    total: number;
    nextEpisode?: { __typename?: "Episode"; id: string; number: number } | null;
  };
} & { " $fragmentName"?: "CatalogShowFragmentFragment" };

export type SectionContentFragmentFragment = {
  __typename?: "SectionContent";
  shows: Array<{
    __typename?: "DefaultOrderedShow";
    order: number;
    show: { __typename?: "Show" } & {
      " $fragmentRefs"?: {
        CatalogShowFragmentFragment: CatalogShowFragmentFragment;
      };
    };
  }>;
} & { " $fragmentName"?: "SectionContentFragmentFragment" };

export type UserFragmentFragment = {
  __typename?: "User";
  id: string;
  trackingId: string;
  name?: string | null;
  email?: string | null;
  views: number;
  providers: Array<SocialProvider>;
  isPremium: boolean;
  providersData: Array<{
    __typename?: "UserSocialProvider";
    provider: SocialProvider;
    email?: string | null;
    createdAt: any;
    updatedAt: any;
  }>;
  premium?: {
    __typename?: "Premium";
    productId: string;
    platform: DeviceType;
  } | null;
} & { " $fragmentName"?: "UserFragmentFragment" };

export type BookmarkMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type BookmarkMutation = {
  __typename?: "Mutation";
  bookmark: Array<{ __typename?: "Show"; id: string; isBookmarked: boolean }>;
};

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteAccountMutation = {
  __typename?: "Mutation";
  deleteAccount: { __typename?: "Auth"; token: string };
};

export type LikeMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  percentage: Scalars["Float"]["input"];
}>;

export type LikeMutation = {
  __typename?: "Mutation";
  like: { __typename?: "Episode"; id: string; liked: boolean; likes: number };
};

export type LinkAppleProviderMutationVariables = Exact<{
  providerInput: SocialProviderInput;
}>;

export type LinkAppleProviderMutation = {
  __typename?: "Mutation";
  linkAppleProvider: {
    __typename?: "Auth";
    token: string;
    user: { __typename?: "User" } & {
      " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
    };
  };
};

export type LinkEmailProviderMutationVariables = Exact<{
  providerInput: SocialProviderInput;
  email: Scalars["String"]["input"];
}>;

export type LinkEmailProviderMutation = {
  __typename?: "Mutation";
  linkEmailProvider: {
    __typename?: "Auth";
    token: string;
    user: { __typename?: "User" } & {
      " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
    };
  };
};

export type LinkFacebookProviderMutationVariables = Exact<{
  providerInput: SocialProviderInput;
}>;

export type LinkFacebookProviderMutation = {
  __typename?: "Mutation";
  linkFacebookProvider: {
    __typename?: "Auth";
    token: string;
    user: { __typename?: "User" } & {
      " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
    };
  };
};

export type LinkGoogleProviderMutationVariables = Exact<{
  providerInput: SocialProviderInput;
}>;

export type LinkGoogleProviderMutation = {
  __typename?: "Mutation";
  linkGoogleProvider: {
    __typename?: "Auth";
    token: string;
    user: { __typename?: "User" } & {
      " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
    };
  };
};

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;

export type RegisterMutation = {
  __typename?: "Mutation";
  register: {
    __typename?: "Auth";
    token: string;
    user: { __typename?: "User" } & {
      " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
    };
  };
};

export type SendEmailLinkMutationVariables = Exact<{
  email?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SendEmailLinkMutation = {
  __typename?: "Mutation";
  sendEmailLink: boolean;
};

export type UnbookmarkMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type UnbookmarkMutation = {
  __typename?: "Mutation";
  unbookmark: Array<{ __typename?: "Show"; id: string; isBookmarked: boolean }>;
};

export type UnlikeMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  percentage: Scalars["Float"]["input"];
}>;

export type UnlikeMutation = {
  __typename?: "Mutation";
  unlike: { __typename?: "Episode"; id: string; liked: boolean; likes: number };
};

export type UnlinkSocialProviderMutationVariables = Exact<{
  provider: SocialProvider;
}>;

export type UnlinkSocialProviderMutation = {
  __typename?: "Mutation";
  unlinkSocialProvider: {
    __typename?: "User";
    providers: Array<SocialProvider>;
    providersData: Array<{
      __typename?: "UserSocialProvider";
      provider: SocialProvider;
      email?: string | null;
      createdAt: any;
      updatedAt: any;
    }>;
  };
};

export type UntrackMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type UntrackMutation = {
  __typename?: "Mutation";
  untrack: Array<{ __typename?: "Show"; id: string }>;
};

export type WatchedMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type WatchedMutation = { __typename?: "Mutation"; watched: boolean };

export type GetActorShowsQueryVariables = Exact<{
  actorId: Scalars["ID"]["input"];
  withProgression?: Scalars["Boolean"]["input"];
  withBookmarkState?: Scalars["Boolean"]["input"];
}>;

export type GetActorShowsQuery = {
  __typename?: "Query";
  actorShows: Array<
    {
      __typename?: "Show";
      actors: Array<{ __typename?: "Actor"; id: string; fullName: string }>;
    } & {
      " $fragmentRefs"?: {
        CatalogShowFragmentFragment: CatalogShowFragmentFragment;
      };
    }
  >;
};

export type GetBookmarkedShowsQueryVariables = Exact<{
  withProgression?: Scalars["Boolean"]["input"];
  withBookmarkState?: Scalars["Boolean"]["input"];
}>;

export type GetBookmarkedShowsQuery = {
  __typename?: "Query";
  bookmarkedShows: Array<{
    __typename?: "BookmarkedShow";
    order: number;
    show: { __typename?: "Show" } & {
      " $fragmentRefs"?: {
        CatalogShowFragmentFragment: CatalogShowFragmentFragment;
      };
    };
  }>;
};

export type GetCatalogLayoutQueryVariables = Exact<{
  withProgression?: Scalars["Boolean"]["input"];
  withBookmarkState?: Scalars["Boolean"]["input"];
}>;

export type GetCatalogLayoutQuery = {
  __typename?: "Query";
  catalogLayout: {
    __typename?: "CatalogLayout";
    tabs: Array<{
      __typename?: "CatalogTabLayout";
      id: string;
      order: number;
      sections: Array<
        { __typename?: "SectionLayout" } & {
          " $fragmentRefs"?: {
            CatalogSectionFragmentFragment: CatalogSectionFragmentFragment;
          };
        }
      >;
    }>;
  };
};

export type GetGoogleOAuthParametersQueryVariables = Exact<{
  code: Scalars["String"]["input"];
  redirectUri: Scalars["String"]["input"];
}>;

export type GetGoogleOAuthParametersQuery = {
  __typename?: "Query";
  getGoogleOAuthParameters: {
    __typename?: "GoogleOAuthParameters";
    accessToken?: string | null;
    refreshToken?: string | null;
    scope?: string | null;
    idToken?: string | null;
    tokenType?: string | null;
    expiresIn?: string | null;
  };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: "Query";
  me: { __typename?: "User" } & {
    " $fragmentRefs"?: { UserFragmentFragment: UserFragmentFragment };
  };
};

export type GetMostTrendingShowQueryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetMostTrendingShowQueryQuery = {
  __typename?: "Query";
  mostTrending: Array<{
    __typename?: "MostTrendingShow";
    show: {
      __typename?: "Show";
      id: string;
      displayTitle: string;
      displayThumbnail: { __typename?: "ImageSizes"; original: string };
    };
  }>;
};

export type OneLinkDeeplinkUrlQueryVariables = Exact<{ [key: string]: never }>;

export type OneLinkDeeplinkUrlQuery = {
  __typename?: "Query";
  oneLinkDeeplinkUrl: string;
};

export type GetRecapQueryVariables = Exact<{ [key: string]: never }>;

export type GetRecapQuery = {
  __typename?: "Query";
  yearlyWrapped?: {
    __typename?: "YearlyWrapped";
    recommendationId?: string | null;
    recommendedShows: Array<{
      __typename?: "DefaultOrderedShow";
      show: {
        __typename?: "Show";
        id: string;
        views: number;
        title: string;
        episodesCount: number;
        thumbnail: { __typename?: "ImageSizes"; original: string };
      };
    }>;
    shortsWrapped: {
      __typename?: "YearlyShortsWrapped";
      topTags: Array<string>;
      topFemaleActor: {
        __typename?: "Actor";
        fullName: string;
        gender?: Gender | null;
        image: { __typename?: "ImageSizes"; original: string };
      };
      topMaleActor: {
        __typename?: "Actor";
        fullName: string;
        gender?: Gender | null;
        image: { __typename?: "ImageSizes"; original: string };
      };
      mostWatchedShows: Array<{
        __typename?: "Show";
        id: string;
        title: string;
        thumbnail: { __typename?: "ImageSizes"; original: string };
      }>;
    };
    userWrapped?: {
      __typename?: "YearlyUserWrapped";
      totalDurationWatched: number;
      totalEpisodesWatched: number;
      topTags: Array<string>;
      percentile: number;
      rank: number;
      totalUsers: number;
      mostWatchedShows: Array<{
        __typename?: "Show";
        id: string;
        title: string;
        thumbnail: { __typename?: "ImageSizes"; original: string };
      }>;
      topMaleActor: {
        __typename?: "Actor";
        fullName: string;
        gender?: Gender | null;
        image: { __typename?: "ImageSizes"; original: string };
      };
      topFemaleActor: {
        __typename?: "Actor";
        fullName: string;
        gender?: Gender | null;
        image: { __typename?: "ImageSizes"; original: string };
      };
    } | null;
  } | null;
};

export type GetRecentlyViewedQueryVariables = Exact<{
  withProgression?: Scalars["Boolean"]["input"];
  withBookmarkState?: Scalars["Boolean"]["input"];
}>;

export type GetRecentlyViewedQuery = {
  __typename?: "Query";
  recentlyViewed: Array<{
    __typename?: "RecentlyViewedShow";
    order: number;
    show: { __typename?: "Show" } & {
      " $fragmentRefs"?: {
        CatalogShowFragmentFragment: CatalogShowFragmentFragment;
      };
    };
  }>;
};

export type GetRelatedShowsQueryVariables = Exact<{
  showId: Scalars["ID"]["input"];
  limit: Scalars["Int"]["input"];
  offset?: Scalars["Int"]["input"];
  withProgression?: Scalars["Boolean"]["input"];
  withBookmarkState?: Scalars["Boolean"]["input"];
}>;

export type GetRelatedShowsQuery = {
  __typename?: "Query";
  relatedShows: {
    __typename?: "RelatedShowsResult";
    shows: Array<
      { __typename?: "Show" } & {
        " $fragmentRefs"?: {
          CatalogShowFragmentFragment: CatalogShowFragmentFragment;
        };
      }
    >;
  };
};

export type GetSectionContentQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  withProgression?: Scalars["Boolean"]["input"];
  withBookmarkState?: Scalars["Boolean"]["input"];
}>;

export type GetSectionContentQuery = {
  __typename?: "Query";
  sectionContent: { __typename?: "SectionContent" } & {
    " $fragmentRefs"?: {
      SectionContentFragmentFragment: SectionContentFragmentFragment;
    };
  };
};

export type GetSeriesBehindTheScenesQueryVariables = Exact<{
  showId: Scalars["ID"]["input"];
}>;

export type GetSeriesBehindTheScenesQuery = {
  __typename?: "Query";
  show: {
    __typename?: "Show";
    id: string;
    behindTheScenes: Array<{
      __typename?: "Bts";
      id: string;
      title: string;
      displayTitle: string;
      locked: boolean;
      url?: any | null;
      thumbnail: { __typename?: "ImageSizes"; original: string };
    }>;
  };
};

export type GetSeriesDetailsQueryVariables = Exact<{
  showId: Scalars["ID"]["input"];
}>;

export type GetSeriesDetailsQuery = {
  __typename?: "Query";
  show: {
    __typename?: "Show";
    id: string;
    title: string;
    displayTitle: string;
    displayDescription: string;
    displayTags: Array<string>;
    mostTrendingRank?: number | null;
    views: number;
    episodesCount: number;
    publishedAt?: any | null;
    createdAt: any;
    unlisted: boolean;
    displayImage: { __typename?: "ImageSizes"; original: string };
    displayThumbnail: { __typename?: "ImageSizes"; original: string };
    displayHorizontalThumbnail?: {
      __typename?: "ImageSizes";
      original: string;
    } | null;
    displayTitleImage: { __typename?: "ImageSizes"; original: string };
    actors: Array<{
      __typename?: "Actor";
      id: string;
      fullName: string;
      showsCount: number;
      image: { __typename?: "ImageSizes"; original: string };
    }>;
    episodes: Array<{
      __typename?: "Episode";
      id: string;
      number: number;
      length: number;
      free: boolean;
      url: any;
      hasTimelineThumbnails: boolean;
    }>;
  };
};

export type GetSeriesProgressionQueryVariables = Exact<{
  showId: Scalars["ID"]["input"];
}>;

export type GetSeriesProgressionQuery = {
  __typename?: "Query";
  show: {
    __typename?: "Show";
    id: string;
    progression: {
      __typename?: "Progression";
      progress: number;
      total: number;
      nextEpisode?: {
        __typename?: "Episode";
        id: string;
        number: number;
      } | null;
    };
  };
};

export type GetShowBookmarkStateQueryVariables = Exact<{
  showId: Scalars["ID"]["input"];
}>;

export type GetShowBookmarkStateQuery = {
  __typename?: "Query";
  show: { __typename?: "Show"; id: string; isBookmarked: boolean };
};

export type GetShowLikeStateQueryVariables = Exact<{
  showId: Scalars["ID"]["input"];
}>;

export type GetShowLikeStateQuery = {
  __typename?: "Query";
  show: {
    __typename?: "Show";
    id: string;
    episodes: Array<{
      __typename?: "Episode";
      id: string;
      liked: boolean;
      likes: number;
    }>;
  };
};

export type GetShowQueryVariables = Exact<{
  showId: Scalars["ID"]["input"];
}>;

export type GetShowQuery = {
  __typename?: "Query";
  show: {
    __typename?: "Show";
    id: string;
    displayTitle: string;
    displayDescription: string;
    likes: number;
    bookmarks: number;
    episodesCount: number;
    title: string;
    publishedAt?: any | null;
    createdAt: any;
    unlisted: boolean;
    displayHorizontalThumbnail?: {
      __typename?: "ImageSizes";
      original: string;
    } | null;
    displayImage: { __typename?: "ImageSizes"; original: string };
    displayThumbnail: { __typename?: "ImageSizes"; original: string };
    episodes: Array<{
      __typename?: "Episode";
      id: string;
      number: number;
      url: any;
      free: boolean;
    }>;
  };
};

export type GetShowThumbnailsQueryVariables = Exact<{ [key: string]: never }>;

export type GetShowThumbnailsQuery = {
  __typename?: "Query";
  shows: Array<{
    __typename?: "Show";
    id: string;
    displayThumbnail: { __typename?: "ImageSizes"; original: string };
  }>;
};

export type GetTrendingShowsQueryVariables = Exact<{
  withProgression?: Scalars["Boolean"]["input"];
  withBookmarkState?: Scalars["Boolean"]["input"];
}>;

export type GetTrendingShowsQuery = {
  __typename?: "Query";
  mostTrending: Array<{
    __typename?: "MostTrendingShow";
    order: number;
    show: { __typename?: "Show" } & {
      " $fragmentRefs"?: {
        CatalogShowFragmentFragment: CatalogShowFragmentFragment;
      };
    };
  }>;
};

export type SupportTokenQueryVariables = Exact<{ [key: string]: never }>;

export type SupportTokenQuery = {
  __typename?: "Query";
  supportToken: { __typename?: "SupportToken"; token: string };
};

export type PremiumSubscriptionVariables = Exact<{ [key: string]: never }>;

export type PremiumSubscription = {
  __typename?: "Subscription";
  premium?: {
    __typename?: "Premium";
    productId: string;
    platform: DeviceType;
  } | null;
};

export const CatalogShowFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CatalogShowFragmentFragment, unknown>;
export const SectionContentFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SectionContent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SectionContentFragmentFragment, unknown>;
export const CatalogSectionFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SectionLayout" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "toRefresh" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "HorizontalGridSectionLayout",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "rows" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerticalGridSectionLayout" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columns" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CarouselSectionLayout" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "variation" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "showLayout" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverLayout" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "DefaultCoverLayout" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "badge" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "counterSize" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rankType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "titleImage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "progression" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detailsLayout" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rankType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "episodeCount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionContentFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SectionContent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CatalogSectionFragmentFragment, unknown>;
export const UserFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackingId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "providers" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "providersData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isPremium" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const BookmarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Bookmark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bookmark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isBookmarked" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BookmarkMutation, BookmarkMutationVariables>;
export const DeleteAccountDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteAccount" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteAccount" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAccountMutation,
  DeleteAccountMutationVariables
>;
export const LikeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Like" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "percentage" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "like" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "percentage" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "percentage" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "liked" } },
                { kind: "Field", name: { kind: "Name", value: "likes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LikeMutation, LikeMutationVariables>;
export const LinkAppleProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkAppleProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "providerInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SocialProviderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "linkAppleProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "providerInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "providerInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UserFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackingId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "providers" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "providersData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isPremium" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LinkAppleProviderMutation,
  LinkAppleProviderMutationVariables
>;
export const LinkEmailProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkEmailProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "providerInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SocialProviderInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "linkEmailProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "providerInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "providerInput" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UserFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackingId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "providers" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "providersData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isPremium" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LinkEmailProviderMutation,
  LinkEmailProviderMutationVariables
>;
export const LinkFacebookProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkFacebookProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "providerInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SocialProviderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "linkFacebookProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "providerInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "providerInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UserFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackingId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "providers" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "providersData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isPremium" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LinkFacebookProviderMutation,
  LinkFacebookProviderMutationVariables
>;
export const LinkGoogleProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LinkGoogleProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "providerInput" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SocialProviderInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "linkGoogleProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "providerInput" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "providerInput" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UserFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackingId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "providers" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "providersData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isPremium" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LinkGoogleProviderMutation,
  LinkGoogleProviderMutationVariables
>;
export const RegisterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Register" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RegisterInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "register" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "UserFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackingId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "providers" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "providersData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isPremium" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const SendEmailLinkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SendEmailLink" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sendEmailLink" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendEmailLinkMutation,
  SendEmailLinkMutationVariables
>;
export const UnbookmarkDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Unbookmark" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unbookmark" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isBookmarked" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnbookmarkMutation, UnbookmarkMutationVariables>;
export const UnlikeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Unlike" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "percentage" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unlike" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "percentage" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "percentage" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "liked" } },
                { kind: "Field", name: { kind: "Name", value: "likes" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnlikeMutation, UnlikeMutationVariables>;
export const UnlinkSocialProviderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UnlinkSocialProvider" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "provider" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SocialProvider" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "unlinkSocialProvider" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "provider" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "provider" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "providers" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "providersData" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "provider" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UnlinkSocialProviderMutation,
  UnlinkSocialProviderMutationVariables
>;
export const UntrackDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Untrack" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "ids" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "ID" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "untrack" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "ids" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "ids" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UntrackMutation, UntrackMutationVariables>;
export const WatchedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Watched" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "watched" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WatchedMutation, WatchedMutationVariables>;
export const GetActorShowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetActorShows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "actorId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withProgression" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withBookmarkState" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "actorShows" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "actorId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "actorId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CatalogShowFragment" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "actors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActorShowsQuery, GetActorShowsQueryVariables>;
export const GetBookmarkedShowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetBookmarkedShows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withProgression" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withBookmarkState" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "bookmarkedShows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetBookmarkedShowsQuery,
  GetBookmarkedShowsQueryVariables
>;
export const GetCatalogLayoutDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetCatalogLayout" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withProgression" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withBookmarkState" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "catalogLayout" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "tabs" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "order" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sections" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CatalogSectionFragment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SectionContent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogSectionFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SectionLayout" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          { kind: "Field", name: { kind: "Name", value: "order" } },
          { kind: "Field", name: { kind: "Name", value: "toRefresh" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "type" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {
                      kind: "Name",
                      value: "HorizontalGridSectionLayout",
                    },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "rows" } },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "VerticalGridSectionLayout" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "columns" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "CarouselSectionLayout" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "variation" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "showLayout" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coverLayout" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "__typename" },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "DefaultCoverLayout" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "size" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "badge" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "counterSize" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rankType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "titleImage" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "progression" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "detailsLayout" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "placement" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      { kind: "Field", name: { kind: "Name", value: "tag" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rankType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "episodeCount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "content" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionContentFragment" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCatalogLayoutQuery,
  GetCatalogLayoutQueryVariables
>;
export const GetGoogleOAuthParametersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetGoogleOAuthParameters" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "code" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "redirectUri" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getGoogleOAuthParameters" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "code" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "code" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "redirectUri" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "redirectUri" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accessToken" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "scope" } },
                { kind: "Field", name: { kind: "Name", value: "idToken" } },
                { kind: "Field", name: { kind: "Name", value: "tokenType" } },
                { kind: "Field", name: { kind: "Name", value: "expiresIn" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetGoogleOAuthParametersQuery,
  GetGoogleOAuthParametersQueryVariables
>;
export const MeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Me" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "me" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "UserFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "UserFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "trackingId" } },
          { kind: "Field", name: { kind: "Name", value: "name" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "providers" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "providersData" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "provider" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
          { kind: "Field", name: { kind: "Name", value: "isPremium" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const GetMostTrendingShowQueryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMostTrendingShowQuery" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostTrending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayThumbnail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMostTrendingShowQueryQuery,
  GetMostTrendingShowQueryQueryVariables
>;
export const OneLinkDeeplinkUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OneLinkDeeplinkUrl" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "oneLinkDeeplinkUrl" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OneLinkDeeplinkUrlQuery,
  OneLinkDeeplinkUrlQueryVariables
>;
export const GetRecapDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecap" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "yearlyWrapped" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendationId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recommendedShows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "show" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "views" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "episodesCount" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shortsWrapped" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topTags" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topFemaleActor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gender" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topMaleActor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gender" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mostWatchedShows" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "userWrapped" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalDurationWatched" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalEpisodesWatched" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topTags" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mostWatchedShows" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "thumbnail" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topMaleActor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gender" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topFemaleActor" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "fullName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "gender" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "image" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "original" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "percentile" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rank" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "totalUsers" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRecapQuery, GetRecapQueryVariables>;
export const GetRecentlyViewedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecentlyViewed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withProgression" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withBookmarkState" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recentlyViewed" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRecentlyViewedQuery,
  GetRecentlyViewedQueryVariables
>;
export const GetRelatedShowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRelatedShows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "showId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
          defaultValue: { kind: "IntValue", value: "0" },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withProgression" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withBookmarkState" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "relatedShows" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "showId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "showId" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "shows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRelatedShowsQuery,
  GetRelatedShowsQueryVariables
>;
export const GetSectionContentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSectionContent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withProgression" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withBookmarkState" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "sectionContent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SectionContentFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SectionContentFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "SectionContent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSectionContentQuery,
  GetSectionContentQueryVariables
>;
export const GetSeriesBehindTheScenesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSeriesBehindTheScenes" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "showId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "show" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "showId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "behindTheScenes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "displayTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "locked" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thumbnail" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSeriesBehindTheScenesQuery,
  GetSeriesBehindTheScenesQueryVariables
>;
export const GetSeriesDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSeriesDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "showId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "show" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "showId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayDescription" },
                },
                { kind: "Field", name: { kind: "Name", value: "displayTags" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayThumbnail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayHorizontalThumbnail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayTitleImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mostTrendingRank" },
                },
                { kind: "Field", name: { kind: "Name", value: "views" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "episodesCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "unlisted" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "actors" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fullName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "showsCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "image" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "original" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "episodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "length" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "free" } },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasTimelineThumbnails" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSeriesDetailsQuery,
  GetSeriesDetailsQueryVariables
>;
export const GetSeriesProgressionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetSeriesProgression" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "showId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "show" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "showId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "progression" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "progress" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nextEpisode" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "number" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetSeriesProgressionQuery,
  GetSeriesProgressionQueryVariables
>;
export const GetShowBookmarkStateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShowBookmarkState" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "showId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "show" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "showId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "isBookmarked" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetShowBookmarkStateQuery,
  GetShowBookmarkStateQueryVariables
>;
export const GetShowLikeStateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShowLikeState" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "showId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "show" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "showId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "episodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "liked" } },
                      { kind: "Field", name: { kind: "Name", value: "likes" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetShowLikeStateQuery,
  GetShowLikeStateQueryVariables
>;
export const GetShowDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShow" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "showId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "show" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "showId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayTitle" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayDescription" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayHorizontalThumbnail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayImage" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayThumbnail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "likes" } },
                { kind: "Field", name: { kind: "Name", value: "bookmarks" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "episodesCount" },
                },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "unlisted" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "episodes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                      { kind: "Field", name: { kind: "Name", value: "free" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetShowQuery, GetShowQueryVariables>;
export const GetShowThumbnailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetShowThumbnails" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "shows" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "displayThumbnail" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "original" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetShowThumbnailsQuery,
  GetShowThumbnailsQueryVariables
>;
export const GetTrendingShowsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetTrendingShows" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withProgression" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "withBookmarkState" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
          defaultValue: { kind: "BooleanValue", value: false },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mostTrending" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "order" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "show" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CatalogShowFragment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CatalogShowFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Show" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "displayTitle" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayDescription" },
          },
          { kind: "Field", name: { kind: "Name", value: "displayTags" } },
          { kind: "Field", name: { kind: "Name", value: "views" } },
          { kind: "Field", name: { kind: "Name", value: "episodesCount" } },
          { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
          { kind: "Field", name: { kind: "Name", value: "badgeType" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
                { kind: "Field", name: { kind: "Name", value: "medium" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayHorizontalThumbnail" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "displayTitleImage" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "original" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "progression" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withProgression" },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "progress" } },
                { kind: "Field", name: { kind: "Name", value: "total" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "nextEpisode" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "isBookmarked" },
            directives: [
              {
                kind: "Directive",
                name: { kind: "Name", value: "include" },
                arguments: [
                  {
                    kind: "Argument",
                    name: { kind: "Name", value: "if" },
                    value: {
                      kind: "Variable",
                      name: { kind: "Name", value: "withBookmarkState" },
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetTrendingShowsQuery,
  GetTrendingShowsQueryVariables
>;
export const SupportTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SupportToken" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "supportToken" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "token" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SupportTokenQuery, SupportTokenQueryVariables>;
export const PremiumDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "subscription",
      name: { kind: "Name", value: "Premium" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "premium" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "productId" } },
                { kind: "Field", name: { kind: "Name", value: "platform" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PremiumSubscription, PremiumSubscriptionVariables>;
